// extracted by mini-css-extract-plugin
export var table = "d90627372bcfd7d68efc641589d97982-css";